///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { GtthMultipleAutoDesignCommand } from '../../logical-topology/engine/commands/design/multiple-auto-desing-command';
import { GtthProgressWindowService } from '../../project-windows/progress-window/progress-window.service';
import { GtthProgressWindowModel } from '../../project-windows/progress-window/progress-window.model';
import { GtthAutoDesignCommand } from '../../logical-topology/engine/commands/design/auto-design-command';
import { GtthNotificationsService } from '../../logical-topology/engine/notifications-service';
import { GtthProjectUserSessionService } from '../../logical-topology/engine/project-user-session.service';
import { GtthProjectStateService } from '../../logical-topology/engine/project-state.service';
import { Router } from '@angular/router';

@Component({
    selector: 'winde-step-plan',
    templateUrl: './step-plan.component.html',
    styleUrls: ['./step-plan.scss', '../steps-toolbar.scss'],
    standalone: false
})
export class GtthStepPlanComponent {
    constructor(
        public readonly historyService: GtthHistoryService,
        private readonly progressWindowService: GtthProgressWindowService,
        private readonly notificationService: GtthNotificationsService,
        public readonly projectUserSessionService: GtthProjectUserSessionService,
        public readonly projectStateService: GtthProjectStateService,
        private readonly router: Router
    ) {}

    startAutoPlan() {
        if (!this.historyService.logicalTopology.hasPopStationsInTopmostLayer()) {
            this.notificationService.showError('No POP found, or POP not connected. No optimization performed');
            return;
        }

        if (this.historyService.logicalTopology.selectedProductsContainsMhTgBu(this.historyService.projectProductsService)) {
            if (!this.historyService.logicalTopology.getIsIpConfigDefined()) {
                this.notificationService.showError(
                    'In order to complete design, please specify the "Start IP address", "Subnet mask width" and "Default GW IP" fields in Project settings -> NW config tab'
                );
                return;
            }

            if (!this.historyService.logicalTopology.exportLinksConfig.checkGateWayValidityBySubnetwork()) {
                this.notificationService.showError('In order to complete design, "Default GW IP" must belong to subnetwork');
                return;
            }
        }

        let designCommand;

        if (this.projectUserSessionService.isAutoRepeatDesign) {
            designCommand = this.historyService.command(GtthMultipleAutoDesignCommand).create();
        } else {
            designCommand = this.historyService.command(GtthAutoDesignCommand).create();
        }

        this.historyService.doCommand(designCommand);
    }

    openDesignResults() {
        this.progressWindowService.show(GtthProgressWindowModel.createMultipleFromHistory(this.historyService));
    }

    showSectors() {
        if (this.projectUserSessionService.isShowSectors) {
            this.projectUserSessionService.isShowAllSectors = false;
        }
        this.historyService.logicalTopology.clearNodeNamesSectorsToShow();
        this.historyService.logicalTopology.redrawSectors(this.historyService);
    }

    showAllSectors() {
        if (this.projectUserSessionService.isShowAllSectors) {
            this.projectUserSessionService.isShowSectors = false;
        }
        this.historyService.logicalTopology.clearNodeNamesSectorsToShow();
        this.historyService.logicalTopology.redrawSectors(this.historyService);
    }

    startMigration(): void {
        this.historyService.closeInfoWindows();
        this.router.navigate([{ outlets: { popup: `projects/${this.projectStateService.getProjectId()}/migrate` } }]);
    }

    startAreaPlannerDesign() {
        if (!this.historyService.logicalTopology.hasPopStationsInTopmostLayer()) {
            this.notificationService.showError('No POP found, or POP not connected. No optimization performed');
            return;
        }

        this.historyService.doCommand(this.historyService.command(GtthAutoDesignCommand).create());
    }
}
